
require('rangeslider.js');

$(document).ready(function () {
    initServiceLenghtSlider();
    initServiceHoursSlider();
    // service - hours
});

function initServiceLenghtSlider() {
    const $element = $('#service-lenght');
    var $handle;

    $element
        .rangeslider({
            polyfill: false,
            onInit: function () {
                $handle = $('.rangeslider__handle', this.$range);
                updateHandle($handle[0], getDisplayValue(this.value), 'MONTHLY');
            }
        })
        .on('input', function () {
            updateHandle($handle[0], getDisplayValue(this.value), 'MONTHLY');
        });
    
    function getDisplayValue(val)
    {
        switch (val) {
            case '1':
                return 3;
                break;
            case '2':
                return 6;
                break;
            case '3':
                return 12;
                break;
            default:
                return 12;
        }
    }
}

function initServiceHoursSlider() {
    const $element = $('#service-hours');
    var $handle;

    $element
        .rangeslider({
            polyfill: false,
            onInit: function () {
                $handle = $('.rangeslider__handle', this.$range);
                updateHandle($handle[0], this.value, 'HOURS');
            }
        })
        .on('input', function () {
            updateHandle($handle[0], this.value, 'HOURS');
        });
}

// Update the value inside the slider handle
function updateHandle(el, val, label = '') {
    var handleEl = $(`
        <div class="quotation-handle">
            <div>${val}</div>
            <div class="handle-label">
                ${label}
            </div>
        </div>
    `);

    $(el).html(handleEl);
}